<!-- Dialog Content -->
<div class="dialog-content">
  <div class="dialog-header">
    <h2 mat-dialog-title>
      <span *ngIf="mode === 'add' && data.watchlist">Add Companies to Watchlist: {{data.watchlist.watchlist_name}}</span>
      <span *ngIf="mode === 'add' && data.benchmark">Add Companies to Benchmark: {{data.benchmark.benchmark_name}}</span>
      <span *ngIf="mode === 'edit'">Edit Match for: {{editMatch?.input_data?.name || 'Company'}}</span>
    </h2>
    <button mat-icon-button (click)="closePopup()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Watchlist limit warning -->
  <div class="message-container" *ngIf="mode === 'add'">
    <div class="alert alert-info d-flex align-items-center" *ngIf="remainingSlots > 0">
      <i class="material-icons me-2">info</i>
      <span>Watchlist has {{ currentCount }}/{{ maxCompanies }} companies. You can add {{ remainingSlots }} more.</span>
    </div>
    <div class="alert alert-danger d-flex align-items-center" *ngIf="remainingSlots === 0">
      <i class="material-icons me-2">error</i>
      <span>Watchlist is full. You cannot add more companies.</span>
    </div>
  </div>

  <!-- Success and Error messages -->
  <div class="message-container" *ngIf="successMessage || errorMessage">
    <div class="success-message" *ngIf="successMessage">
      <mat-icon>check_circle</mat-icon>
      <span>{{successMessage}}</span>
    </div>
    <div class="error-message" *ngIf="errorMessage">
      <mat-icon>error</mat-icon>
      <span>{{errorMessage}}</span>
    </div>
  </div>

  <!-- Dialog Body -->
  <div mat-dialog-content class="dialog-body">
    <p class="search-description">
      Find the company you are looking for by entering the legal company name, ISIN or website URL.
    </p>

    <form class="row search-form" [formGroup]="companySearchForm">
      <div class="col-auto">
        <label class="visually-hidden">Company Name</label>
        <input type="text" class="form-control" placeholder="Company Name (Legal)" formControlName="name">
      </div>
      <span class="col-auto align-self-center">or</span>
      <div class="col-auto">
        <label class="visually-hidden">ISIN</label>
        <input type="text" class="form-control" placeholder="ISIN" formControlName="isin">
      </div>
      <span class="col-auto align-self-center">or</span>
      <div class="col-auto">
        <label for="url" class="visually-hidden">URL</label>
        <input type="text" class="form-control" placeholder="URL" formControlName="url">
      </div>
      <div class="col-auto" *ngIf="showSpinner">
        <mat-spinner diameter="20"></mat-spinner>
      </div>
      <div class="col-auto">
        <button mat-raised-button class="search-button"  style="color: #ffffff;background: linear-gradient(135deg, #b39cd0 0%, #7c6bb8 100%);"(click)="companySearch()"
          [disabled]="!companySearchForm.value.name && !companySearchForm.value.url && !companySearchForm.value.isin">
          Search
        </button>
      </div>
    </form>

    <!-- Search Results -->
    <div class="card mt-3" *ngIf="companies.length > 0">
      <div class="table-responsive">
        <table class="table table-condensed table-hover">
          <thead>
            <tr>
              <th scope="col">Name</th>
              <th scope="col">Country</th>
              <th scope="col">Region</th>
              <th scope="col">GICS Sub-Industry</th>
              <th scope="col">Inventions (all time)</th>
              <th scope="col">Identifiers</th>
              <th scope="col">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let company of companies | paginate: {id:'pag_company_search_popup', itemsPerPage: 5, currentPage: paginator_page }">
              <td>
                <div class="text"
                  style="max-width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
                  [matTooltip]="company.entity_name">
                  {{ company.entity_name }}
                </div>
                <div class="isin" style="font-size: 14px;color: cadetblue;">
                  {{company.isin}}
                  <a [href]="company.webpage && company.webpage.startsWith('http') ? company.webpage : (company.webpage ? 'http://' + company.webpage : '#')"
                    target="_blank">
                    <i class="bi bi-box-arrow-up-right" style="font-size: 12px;"></i>
                  </a>
                </div>
              </td>
              <td>{{company.country}}</td>
              <td>{{company.region}}</td>
              <td>
                <span *ngIf="company.gsubind_extended_name">{{company.gsubind_extended_name}}</span>
                <span *ngIf="!company.gsubind_extended_name && company.subindustryname">{{company.subindustryname}}</span>
                <span *ngIf="!company.subindustryname && !company.gsubind_extended_name" class="text-muted">
                  <i class="material-icons me-1" style="font-size: 16px; color: #dc3545;">warning</i>
                  No GICS Coverage
                </span>
              </td>
              <td>{{company.n_inventions}}</td>
              <td>
                QIP <i class="bi bi-copy" style="margin-right: 20px;color:#9681D1" matTooltip="Copy Quant IP Entity ID"
                  [cdkCopyToClipboard]="company.entityid"></i> S&P
                <i class="bi bi-copy" style="margin-right: 20px;color:black" matTooltip="Copy Capital IQ Company ID"
                  [cdkCopyToClipboard]="company.companyid?.toString() || ''"></i>
              </td>
                      <td>

                        <div *ngIf="spinnerForAdd">
                          <mat-spinner diameter="20"></mat-spinner>
                        </div>
                        <button  mat-raised-button style="color: #ffffff;background: linear-gradient(135deg, #b39cd0 0%, #7c6bb8 100%);" *ngIf="!spinnerForAdd && !isCompanyInWatchlist(company) && (company.gsubind_extended || company.gsubind)"
                          (click)="addCompanyToWatchlist(company)"
                          [disabled]="spinnerForAdd || isCompanyInWatchlist(company) || (mode === 'add' && remainingSlots <= 0) ">
                          <span *ngIf="mode === 'add'">Add to Watchlist</span>
                          <span *ngIf="mode === 'edit'">Select This Company</span>
                        </button>
                        <!-- disabled button just with text -->
                        <button mat-raised-button color="green" *ngIf="isCompanyInWatchlist(company)" [disabled]="true">
                          <span *ngIf="mode === 'add'">In watchlist</span>
                          <span *ngIf="mode === 'edit'">Already in watchlist</span>
                        </button>
                        <!-- No GICS coverage button -->
                        <button mat-raised-button color="warn" *ngIf="!isCompanyInWatchlist(company) && !company.gsubind_extended && !company.gsubind" [disabled]="true">
                          <i class="material-icons me-1" style="font-size: 16px;">warning</i>
                          No Coverage
                        </button>
                      </td>
            </tr>
          </tbody>
        </table>
      </div>
      <pagination-controls id="pag_company_search_popup" [maxSize]="3" (pageChange)="paginator_page = $event">
      </pagination-controls>
    </div>
  </div>

  <!-- Dialog Actions -->
  <div mat-dialog-actions class="dialog-actions">
    <button mat-button (click)="closePopup()">Done</button>
  </div>
</div>